/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileCaf = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="M11.587 11.887c.244 0 .469.025.676.076s.388.115.545.193v.911a4.285 4.285 0 0 0-.635-.193 2.485 2.485 0 0 0-.51-.056c-.474 0-.838.14-1.09.421-.254.28-.38.68-.38 1.195 0 .556.124.986.372 1.29.249.298.614.448 1.097.448.193 0 .39-.02.587-.062.202-.046.435-.115.697-.207v.897a3.21 3.21 0 0 1-.628.207c-.234.06-.495.09-.78.09-.805 0-1.414-.229-1.828-.684-.414-.46-.621-1.12-.621-1.98 0-.528.101-.982.304-1.359a2.09 2.09 0 0 1 .862-.877c.373-.207.817-.31 1.332-.31zM18.28 17h-1.2l-.333-1.028h-1.85L14.566 17h-1.152l1.904-5.017h1.042zm-3.094-1.938h1.267l-.637-1.972zm6.832-2.167h-2.125v1.262h1.883v.911h-1.883V17h-1.077v-5.017h3.202z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileCaf as FileCaf };
